var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  CardTypes: () => CardTypes,
  Editability: () => Editability,
  FormatsTypes: () => FormatsTypes,
  ScreenSummaryTypes: () => ScreenSummaryTypes,
  ScreenTypes: () => ScreenTypes,
  ScreenWrapperTypes: () => ScreenWrapperTypes
});
var Editability;
(function(Editability2) {
  Editability2["FREE"] = "free";
  Editability2["WARNING"] = "warning";
  Editability2["READONLY"] = "readOnly";
})(Editability || (Editability = {}));
var FormatsTypes;
(function(FormatsTypes2) {
  FormatsTypes2["DATE"] = "date";
  FormatsTypes2["AMOUNT_EURO"] = "amount_euro";
  FormatsTypes2["AMOUNT_DOLLAR_MXN"] = "amount_dollar_MXN";
  FormatsTypes2["PERCENTAGE"] = "percentage";
})(FormatsTypes || (FormatsTypes = {}));
var ScreenTypes;
(function(ScreenTypes2) {
  ScreenTypes2["START"] = "start";
  ScreenTypes2["EDIT"] = "edit";
  ScreenTypes2["CHILD_ADD"] = "child_add";
  ScreenTypes2["SUMMARY"] = "summary";
  ScreenTypes2["SUMMARY_ADD"] = "summary_add";
  ScreenTypes2["SUBSUMMARY_FILTERED"] = "subsummary_filtered";
  ScreenTypes2["SUMMARY_CLASIFICATOR"] = "summary_clasificator";
  ScreenTypes2["WRAPPER"] = "wrapper";
  ScreenTypes2["CHILD"] = "child";
  ScreenTypes2["END"] = "end";
  ScreenTypes2["FILTER_SINGLEOPTION"] = "filter_singleoption";
})(ScreenTypes || (ScreenTypes = {}));
var CardTypes;
(function(CardTypes2) {
  CardTypes2["SUMMARY"] = "summary";
  CardTypes2["CLASSIFY"] = "classify";
  CardTypes2["REAL_ESTATE"] = "real_estate";
  CardTypes2["GROUP"] = "group";
})(CardTypes || (CardTypes = {}));
var ScreenSummaryTypes;
(function(ScreenSummaryTypes2) {
  ScreenSummaryTypes2["INVESTMENTS_SUMMARY"] = "investments_summary";
})(ScreenSummaryTypes || (ScreenSummaryTypes = {}));
var ScreenWrapperTypes;
(function(ScreenWrapperTypes2) {
  ScreenWrapperTypes2["PERSONAL_DATA_PHONE"] = "personal_data_phone";
  ScreenWrapperTypes2["INVESTMENTS_FLANKS"] = "investments_flanks";
  ScreenWrapperTypes2["INVESTMENTS_REPORTS_MANAGER"] = "investments_reports_manager";
  ScreenWrapperTypes2["INVESTMENTS_DOCUMENTS"] = "investments_documents";
  ScreenWrapperTypes2["INVESTMENTS_ENTITIES"] = "investments_entities";
  ScreenWrapperTypes2["INVESTMENTS_CRACKER"] = "investments_cracker";
  ScreenWrapperTypes2["INVESTMENTS_CRYPTO_BROKER"] = "investments_crypto_broker";
  ScreenWrapperTypes2["INVESTMENTS_CRYPTO_AGGREGATOR"] = "investments_crypto_aggregator";
  ScreenWrapperTypes2["DOCUMENTATION"] = "documentation";
})(ScreenWrapperTypes || (ScreenWrapperTypes = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CardTypes,
  Editability,
  FormatsTypes,
  ScreenSummaryTypes,
  ScreenTypes,
  ScreenWrapperTypes
});
